import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";


// Import Public Layout
import AuthenticationLayout from "../layouts/AuthenticationLayout";
import history from "../config/history";
 // Routes the page without any authentication by the user
const AuthRoute = ({ component: Component, ...rest }) => {
  
  const isSignedIn = localStorage.getItem('staySignInAG');
  const hasToken = localStorage.getItem("key");
  const { pathname } = useLocation();

  useEffect(() => {
    if ((isSignedIn && hasToken) || hasToken) {
      const segments = pathname.split('/').filter(Boolean);
      if (segments[0] === "inviteUser") {
        return;
      } else if (segments[0] === "enroll") {
        localStorage.removeItem("staySignInAG");
        localStorage.removeItem("key");
        return;
      }
      if(segments[0] !== "oauth"){
        history.push('/home');
      }
    }
  }, []);

  return (
    <Route {...rest} render={props => (
      <AuthenticationLayout>
        <Component {...props} />
      </AuthenticationLayout>
    )} />
  )
}

// Define Props Types
AuthRoute.propTypes = {
  component: PropTypes.elementType
};

export default AuthRoute;
